import { createContext, useContext } from "react";

// Create context
export const AIChatContext = createContext();

// Custom hook to use the context
export const useAIChatContext = () => {
  const context = useContext(AIChatContext);
  return context;
};
